import { render, staticRenderFns } from "./RecordingAudioModal.vue?vue&type=template&id=5639adfc&scoped=true&"
import script from "./RecordingAudioModal.vue?vue&type=script&lang=ts&"
export * from "./RecordingAudioModal.vue?vue&type=script&lang=ts&"
import style0 from "./RecordingAudioModal.vue?vue&type=style&index=0&id=5639adfc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639adfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VDivider,VRow,VSpacer})
